import { formatEur, formatNumber } from '@/lib/format-es';

const CDN_BASE = 'https://aipeces-media-a4hsbvf5gff3b6b0.z02.azurefd.net';

export function catalogImageUrl(
    blobPath?: string | null,
    principal?: string | null,
    source?: string | null,
): string {
    const candidates = [blobPath, principal, source];
    for (const raw of candidates) {
        const trimmed = String(raw || '').trim();
        if (!trimmed) continue;
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        if (trimmed.startsWith('/rewards/')) return trimmed;
        return `${CDN_BASE}/${trimmed.replace(/^\//, '')}`;
    }
    return '';
}

export const PUBLIC_PRODUCT_BASE = 'https://www.aipeces.com/tienda/p';

export function publicProductUrl(seoSlug: string): string {
    return `${PUBLIC_PRODUCT_BASE}/${encodeURIComponent(seoSlug)}`;
}

export function formatProductPrice(precio: number | null | undefined, moneda?: string): string {
    if (precio == null || !Number.isFinite(Number(precio))) return '—';
    const cur = (moneda || 'EUR').toUpperCase();
    if (cur === 'EUR') return formatEur(Number(precio));
    return `${formatNumber(Number(precio), 2)} ${cur}`;
}

export function availabilityLabel(code?: string | null, text?: string | null): string {
    if (text?.trim()) return text.trim();
    switch ((code || '').toLowerCase()) {
        case 'in_stock':
            return 'En stock';
        case 'out_of_stock':
            return 'Agotado';
        case 'on_order':
            return 'Bajo pedido';
        default:
            if (code && !/^[a-z0-9_]+$/.test(code)) return code;
            return 'Consultar disponibilidad';
    }
}
